import { Grid } from '@mui/material';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import { useWorkspaceContext } from '../../../context';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

const ResumeParsingByEmailPage = () => {
  const loggedInWorkspace = useWorkspaceContext();
  const workspaceName = loggedInWorkspace.link;
  return (
    <SettingsPageLayout
      title="Resume Parsing by Email"
      indexOptions={[{ label: 'Resume Parsing by Email', url: '' }]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages['RESUME_PARSING_BY_EMAIL']
      )}
    >
      <Grid container p={5} rowSpacing={4}>
        <Grid item xs={12}>
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            Parse your Resumes via Email
          </WsTypography>
        </Grid>
        <Grid item>
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.QUATERNARY}>
            You can now forward emails with CV’s to the email given below and they will appear in
            your talent pool. This is extremely useful if you receive Candidate applications in your
            inbox.
          </WsTypography>
        </Grid>
        <Grid container item xs={12}>
          <Grid
            border="solid"
            borderColor={WsColors.TertiaryShades200}
            borderRadius={2}
            width="30%"
            padding={1}
            textAlign="center"
          >
            <WsTypography variant={WsTypoVariants.BODY1}>
              {workspaceName + '@resumes.wisestep.com'}
            </WsTypography>
          </Grid>
        </Grid>
        <Grid item>
          <WsTypography variant={WsTypoVariants.BODY1} bold>
            {'Pro tip : Setup a forwarding filter in your inbox like : from : ' +
              workspaceName +
              '@resumes.wisestep.com - forward email with attachment to:<emailaddressabove>'}
          </WsTypography>
        </Grid>
        <Grid item xs={12}>
          <WsTypography variant={WsTypoVariants.BODY1} bold>
            Guidelines :
          </WsTypography>
        </Grid>
        <Grid item>
          <WsTypography variant={WsTypoVariants.BODY1}>
            1. Only PDF, DOC, DOCX , RTF and HTML attachments will be parsed
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY1}>
            2. CV’s may take some time to get processed and will not appear instantly in the Talent
            Pool
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY1}>
            3. Total Number of emails processed for a workspace is 10,000 emails per day
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY1}>
            4. Zipped files cannot be processed
          </WsTypography>
        </Grid>
      </Grid>
    </SettingsPageLayout>
  );
};
export default ResumeParsingByEmailPage;
